import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'jquery-validation/dist/additional-methods.js'
import moment from 'moment'
import 'expressive-annotations-validate'
import '../../lib/form-poly.js'
import '../../lib/jquery.validate.extension.recaptchasolved.js'

window.SetRequired = function ($elem, required, message) {
	if (required === true)
		$elem.attr("data-val-required", message);
	else
		$elem.removeAttr("data-val-required");
};

window.ReloadValidation = function ($form) {
	$form.removeData('validator');
	$form.removeData('unobtrusiveValidation');
	jQuery.validator.unobtrusive.parse($form);
};

(function ($) {
	// HS Code
	jQuery.validator.unobtrusive.adapters.add("hscode", function (options) {
		options.rules['hscode'] = options.params;
		if (options.message) {
			options.messages['hscode'] = options.message;
		}
	});
	jQuery.validator.addMethod("hscode",
		function (value, element) {
			var regEx = new RegExp(/^\d{6}$/);
			return this.optional(element) || regEx.test(value);
		}, '');

	// Checkbox must be ticked
	jQuery.validator.unobtrusive.adapters.addBool("mustbetrue", "required");

	// replace date validation using moment.js (Chrome always uses US date formats)
	if (typeof (moment) !== undefined) {
		jQuery.validator.addMethod("date", function (value, element) {
			return this.optional(element) || moment(value, "D/M/YYYY", true).isValid();
		}, "Please enter a valid date in the format DD/MM/YYYY");
	}

	// replace number validation to NOT allow thosands separators
	jQuery.validator.addMethod("number", function (value, element) {
		return this.optional(element) || /^(?:-?\d+)?(?:\.\d+)?$/.test(value);
	});

	// Password policy
	jQuery.validator.unobtrusive.adapters.add(
		'passwordpolicy', ['pattern'], function (options) {
			options.rules['passwordpolicy'] = options.params;
			if (options.message) {
				options.messages['passwordpolicy'] = options.message;
			}
		}
	);
	jQuery.validator.addMethod('passwordpolicy', function (value, element, params) {
		var regex = new RegExp(params.pattern);
		return regex.test(value);
	}, '');

	// Max file size
	jQuery.validator.unobtrusive.adapters.add(
		'filesize', ['maxsize'], function (options) {
			options.rules['filesize'] = options.params;
			if (options.message) {
				options.messages['filesize'] = options.message;
			}
		}
	);
	jQuery.validator.addMethod('filesize', function (value, element, params) {
		if (element.files.length < 1) {
			// No files selected
			return true;
		}

		if (!element.files || !element.files[0].size) {
			// This browser doesn't support the HTML5 API
			return true;
		}

		return element.files[0].size <= params.maxsize;
	}, '');

	jQuery.validator.addMethod("requireatleastoneitem", function (value, element) {
		const hasAny = $("#freight-items-tbody tr").length > 0;
		$(element).val(hasAny ? "true" : "false");
		return hasAny;
	});

	jQuery.validator.unobtrusive.adapters.add("requireatleastoneitem", [], function (options) {
		options.rules["requireatleastoneitem"] = true;
		options.messages["requireatleastoneitem"] = options.message;
	});

	$.validator.setDefaults({
		ignore: ":hidden:not([data-val-requireatleastoneitem])"
	});

	// ISO 646 compliant (allowed characters by Customs NZ)
	jQuery.validator.unobtrusive.adapters.add(
		'isosixfoursixcompliant', ['allowlinebreaks'], function (options) {
			options.rules['isosixfoursixcompliant'] = options.params;
			if (options.message) {
				options.messages['isosixfoursixcompliant'] = options.message;
			}
		}
	);
	jQuery.validator.addMethod('isosixfoursixcompliant', function (value, element, params) {
		var allowLineBreaks = params.allowlinebreaks.toLowerCase() === "true";
		var lineFeedCharCode = 10;       // \n
		var carriageReturnCharCode = 13; // \r
		var minCharCode = 32;
		var maxCharCode = 125;

		for (var i = 0; i < value.length; i++) {
			var charCode = value.charCodeAt(i);

			if (charCode >= minCharCode && charCode <= maxCharCode) {
				continue;
			}

			if (allowLineBreaks && (charCode === lineFeedCharCode || charCode === carriageReturnCharCode)) {
				continue;
			}

			return false;
		}

		return true;
	}, '');

})(jQuery);
